<ng-container>
  <div class="btn-group btn-group-justified" role="group" aria-label="...">
    <div class="btn-group" role="group">
      <ng-container *ngIf="showActions">
        <lum-ui-icon
          *ngIf="!key && data.hasFlaggedTag"
          class="mr-3 align-self-center"
          icon="alert-information-circle"
          color="#f24f63"
          [matTooltip]="matTooltipMessage"
          matTooltipPosition="above"
          matTooltipClass="picklist-packing-tooltip__floating"
          matTooltipOffset="0,10"
        ></lum-ui-icon>
        <button
          *ngIf="!key && !data.shippable"
          class="
            lum-button lum-button--tertiary picklist-packing-text__uppercase align-self-center
          "
          mat-button
          [disabled]="true"
        >
          {{ data?.orderStatus }}
        </button>
        <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="!key">
          <lum-ui-icon icon="menu-horizontal" color="#36363A"></lum-ui-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button
            *ngIf="canPrintLabel"
            mat-menu-item
            (click)="printLabelEvent.emit(data.id)"
          >
            <lum-ui-icon
              class="mr-3"
              icon="export-pdf"
              color="#5563d6"
            ></lum-ui-icon>
            Print Label
          </button>
          <button
            *ngIf="canPrintLabel"
            mat-menu-item
            (click)="printLabelWithPackingSlipEvent.emit(data.id)"
          >
            <lum-ui-icon
              class="mr-3"
              icon="export-pdf"
              color="#5563d6"
            ></lum-ui-icon>
            Print Label w/ Packing Slip
          </button>
          <button
            [disabled]="data.hasFlaggedTag"
            mat-menu-item
            (click)="flagOrderEvent.emit(data.id)"
          >
            <lum-ui-icon
              class="mr-3"
              icon="alert-information-circle"
              [color]="data.hasFlaggedTag ? '#95969a' : '#f24f63'"
            ></lum-ui-icon>
            Flag Order
          </button>
          <button
            mat-menu-item
            *ngIf="data.flag && !data.shippable"
            (click)="onHoldEvent.emit(data.id)"
          >
            <lum-ui-icon
              class="mr-3"
              icon="alert-warning-triangle"
              color="#f24f63"
            ></lum-ui-icon>
            Onhold Order
          </button>
          <ng-container *ngIf="data.shippable">
            <button
              *ngIf="!data.verified"
              mat-menu-item
              (click)="verifyEvent.emit(data)"
            >
              <lum-ui-icon
                class="mr-1"
                icon="search"
                color="#5563d6"
                width="22"
                height="22"
              ></lum-ui-icon>
              Verify
            </button>
            <button
              mat-menu-item
              (click)="shipEvent.emit(data.id)"
              [disabled]="isShipDisabled"
            >
              <lum-ui-icon
                class="mr-2"
                icon="shipping"
                color="#5563d6"
                width="16"
              ></lum-ui-icon>
              Ship
            </button>
            <button mat-menu-item (click)="exportPackingSlipEvent.emit(data.id)">
              <lum-ui-icon
                class="mr-3"
                icon="export-pdf"
                color="#5563d6"
              ></lum-ui-icon>
              Export Packing Slip
            </button>
          </ng-container>
        </mat-menu>
      </ng-container>
    </div>
  </div>
</ng-container>
